var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-setting",style:({
    'margin-bottom': (_vm.data.marginBottom ) / 16 + 'rem',
  })},[_c('img',{style:({
      width: (_vm.data.imgWidth ) / 16 + 'rem',
      height: (_vm.data.imgHeight ) / 16 + 'rem',
      'margin-left': (_vm.data.imgMarginLeft ) / 16 + 'rem',
      'margin-right': (_vm.data.imgMarginRight ) / 16 + 'rem',
    }),attrs:{"src":_vm.imgUrl},on:{"click":_vm.changeProtocol}}),_c('div',[_c('span',{style:({
        fontSize: (_vm.data.fontSize ) / 16 + 'rem',
        fontWeight: _vm.data.fontWeight,
        color: _vm.data.titleColor,
      })},[_vm._v(_vm._s(_vm.data.title))]),_vm._l((_vm.data.lists),function(item,index){return _c('span',{key:index,on:{"click":function($event){return _vm.clickProtocol(item)}}},[_c('span',{style:({
          fontSize: (_vm.data.proFontSize ) / 16 + 'rem',
          color: _vm.data.proColor,
        })},[_vm._v(_vm._s(item.title))])])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }